<ion-item lines="none" mode="md" color="white">
  <ion-grid fixed class="ion-no-padding">
    <ion-row class="ion-justify-content-center">
      <ion-col size="6" (click)="ontooltip($event)">
        <ion-button
          expand="full"
          mode="md"
          color="darkblue"
          size="default"
          [disabled]="!promosCart ? true : isDisabledButton"
          (click)="onAddPromo()"
        >
          <!-- Copy de boton si es actualizar o agregar -->
          <ion-label md="md" class="ion-text-capitalize">
            {{
              'Buttons.' +
                (!promosCart
                  ? 'add'
                  : promosCart.PaquetesCanjeados > promo.UltimosCanjeados
                  ? 'upgrade'
                  : 'add') | translate
            }}
          </ion-label>
          <ion-icon
            name="checkmark-circle-outline"
            slot="end"
            color="white"
          ></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-item>

<ion-popover
  #tooltip
  side="top"
  alignment="center"
  show-backdrop="false"
  [isOpen]="isTooltip"
  (didDismiss)="isTooltip = false"
>
  <ng-template>
    <ion-label mode="md" color="tpcta" class="ion-text-center promo-tooltip">
      {{ 'Labels.add-promo-tooltip' | translate }}
    </ion-label>
  </ng-template>
</ion-popover>
